import React, { memo, useContext } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Controller, useForm } from 'react-hook-form';
import Select from "react-select";
import { MeioComunicacaoContext } from '../../../../contexts/MeioComunicacaoContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleLeft, faBroom, faFilter } from '@fortawesome/free-solid-svg-icons';
import MidiaSocialIcone from '../../../../components/MidiaSocialIcone';
import './index.css';
import { ModulosContext } from '../../../../contexts/ModulosContext';
import DommusSwitchControl from '../../../../components/DommusSwitchControl';

export const FiltroTemplate = memo(({filtro, handleAplicarFiltro, closeModal}) => {
  const {meiosComunicacao} = useContext(MeioComunicacaoContext);
  const {modulos} = useContext(ModulosContext);
  const filtroFormatado = {
    meios_comunicacao: filtro?.meios_comunicacao ? Object.fromEntries(filtro.meios_comunicacao.map(meio => [`meio_${meio}`, true])) : {},
    modulos: modulos.filter(modulo => filtro?.modulos?.includes(modulo.id)).map(modulo => ({value: modulo.id, label: modulo.nome})),
    nome: filtro?.nome || '',
    mensagem: filtro?.mensagem || '',
    aprovado_whatsapp: Number(filtro?.aprovado_whatsapp) || 0
  }
  const methods = useForm({defaultValues: filtroFormatado});
  const aprovadoWhatsappWatch = methods.watch('aprovado_whatsapp');

  const handleOnSubmit = (data) => {
    let chaves = Object.keys(data.meios_comunicacao).filter(key => data.meios_comunicacao[key]);
    data.meios_comunicacao = chaves.map(chave => Number(chave.replace('meio_', '')));
    data.modulos = data?.modulos ? data?.modulos?.map(modulo => modulo.value) : [];
    handleAplicarFiltro(data);
  }

  return (
    <Form onSubmit={methods.handleSubmit(handleOnSubmit)}>
      <Row>
        <Col md={4}>
          <Row>
            <Form.Group as={Col}>
              <Form.Label className="inputLabel">Meios de Comunicacao</Form.Label>
              <div className='meios-comunicacao-section'>
                {meiosComunicacao?.map((meio, index) => (
                  <label key={index} htmlFor={`meio-${meio.id}`}>
                    <MidiaSocialIcone midia={meio.slug} />
                    <input 
                      type='checkbox'
                      {...methods.register(`meios_comunicacao.meio_${meio.id}`)}
                      id={`meio-${meio.id}`}
                      hidden
                    />
                  </label>
                ))}
              </div>
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col}>
              <Form.Label className="inputLabel">Aprovado Whastapp</Form.Label>
              <Controller
                name="aprovado_whatsapp"
                control={methods.control}
                render={({onChange, value})=>(
                  <DommusSwitchControl
                      labelInativo="Não"
                      checked={Number(aprovadoWhatsappWatch)}
                      tooltip={Number(aprovadoWhatsappWatch) ? 'Sim' : 'Não'}
                      labelAtivo="Sim"
                      onChange={(event)=>{
                        methods.setValue('aprovado_whatsapp', event?.target?.checked ? '1' : '0')
                      }}
                  />
                )}
              />
            </Form.Group>
          </Row>
        </Col>
        <Col>
          <Row>
            <Form.Group as={Col}>
              <Form.Label className="inputLabel">Nome</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Digite o nome do template"
                {...methods.register('nome')}
              />
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col}>
              <Form.Label className="inputLabel">Mensagem</Form.Label>
              <Form.Control 
                type="text" 
                placeholder="Digite a descrição do template"
                {...methods.register('mensagem')}
              />
            </Form.Group>
          </Row>
          <Row>
            <Form.Group as={Col}>
              <Form.Label className="inputLabel">Módulo</Form.Label>
              <Controller
                  name="modulos"
                  control={methods.control}
                  render={({ field }) => <Select
                      {...field}
                      isMulti
                      placeholder="Selecionar"
                      name="modulos"
                      options={modulos.map(modulo => ({value: modulo.id, label: modulo.nome}))}
                      className="basic-multi-select"
                      classNamePrefix="select"
                  />}
              />
            </Form.Group>
          </Row>
        </Col>
      </Row>
      <Row>
        <Col className="novoTemplate border-top">
          <div className="buttonsTemplate">
            <Button variant="secondary" className="submitTemplate fecharModal" type="button" onClick={() => closeModal()}>
              <FontAwesomeIcon className="mr-1" icon={faArrowAltCircleLeft}/> Fechar
            </Button>
            <Button variant="info" className="mr-2 mt-3" type="button" onClick={() => methods.reset(Object.fromEntries(Object.keys(methods.getValues()).map(k => [k, undefined])) )}>
              <FontAwesomeIcon className="mr-1" icon={faBroom}/> Limpar 
            </Button>
            <Button className="submitTemplate" type="submit">
              <FontAwesomeIcon className="mr-1" icon={faFilter} /> Filtrar 
            </Button>
          </div>
        </Col>
      </Row>
    </Form>
  )
})
